import { createStyles } from "@mantine/core";
import moment from "moment";
import { getPriorityColor } from "../../utils";

const useStyles = createStyles((theme) => ({
  card: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    border: "1px solid transparent",
    width: "100%",
    padding: "8px 16px",
    "& h4": {
      margin: "0",
      fontSize: "14px",
      fontWeight: 500,
      fontFamily: "Inter",
      color: "#A3A3A3",
      textTransform: "capitalize"
    },
  },
  active: {
    background: "#FFF",
    borderColor: "#E5E5E5",
    borderRadius: 4,
    "& h4, & h3": {
      color: "#000",
    },
  },
}));

const MonthWeekCard = ({ day }) => {
  const { classes } = useStyles();

  return (
    <div
      className={`${classes.card} ${
        moment().format("ddd")?.toLowerCase() === day?.toLowerCase()
          ? classes.active
          : ""
      }`}
    >
      <h4>{day}</h4>
    </div>
  );
};

export default MonthWeekCard;
